import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import api from "../services/api";

const LABELS = {
  crm: "VentES CRM",
  bookings: "VentES Bookings",
  inventory: "VentES Inventory",
  billing: "VentES Billing",
  projects: "VentES Project Management",
  storage: "VentES Storage Rental",
};
const STORAGE_KEY = "ssdash_active_apps";

function selectedFor(licensedApps) {
  const saved = JSON.parse(localStorage.getItem(STORAGE_KEY) || "null");
  return Array.isArray(saved)
    ? saved.filter(app => licensedApps.includes(app))
    : licensedApps;
}

function ManageApps() {
  const [apps, setApps] = useState(null);
  const [selected, setSelected] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    api.listApps().then(data => {
      const licensed = Object.keys(data);
      setApps(data);
      setSelected(selectedFor(licensed));
    }).catch(err => setError(err.message));
  }, []);

  const toggle = app => {
    const next = selected.includes(app)
      ? selected.filter(value => value !== app)
      : [...selected, app];
    setSelected(next);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <main className="container mx-auto max-w-4xl px-6 py-8">
        <h1 className="text-3xl font-bold text-gray-900">Manage AI Context</h1>
        <p className="mt-3 text-lg text-gray-600">
          Choose which licensed VentES apps the AI can use in your conversations.
          You can change this at any time without changing your VentES subscriptions.
        </p>

        {error && <div className="mt-6 rounded-lg border border-red-200 bg-red-50 p-4 text-red-800">{error}</div>}
        {!apps && !error && <div className="mt-6 rounded-xl bg-white p-6 shadow-sm">Loading licensed apps…</div>}
        {apps && Object.keys(apps).length === 0 && (
          <div className="mt-6 rounded-xl bg-white p-6 shadow-sm text-gray-600">
            No compatible licensed apps were found. Sign out and back in to refresh your VentES access.
          </div>
        )}
        <div className="mt-8 space-y-4">
          {Object.entries(apps || {}).map(([slug, config]) => {
            const enabled = selected.includes(slug);
            return (
              <label key={slug} className="flex cursor-pointer items-center justify-between rounded-xl bg-white p-6 shadow-sm">
                <div>
                  <div className="text-lg font-semibold text-gray-900">{LABELS[slug] || slug}</div>
                  <div className="mt-1 text-sm text-gray-500">{config.tools.length} AI tools available</div>
                </div>
                <span className="flex items-center gap-3">
                  <span className={`text-sm font-medium ${enabled ? "text-blue-700" : "text-gray-500"}`}>
                    {enabled ? "Included" : "Excluded"}
                  </span>
                  <input type="checkbox" checked={enabled} onChange={() => toggle(slug)} className="h-5 w-5 rounded text-blue-600" />
                </span>
              </label>
            );
          })}
        </div>
      </main>
    </div>
  );
}

export default ManageApps;
